'use strict';

(function () {

  angular.module('specsguardApp')
    .config(AreasConfig);

  AreasConfig.$inject = ['$stateProvider'];

  function AreasConfig ($stateProvider) {

    $stateProvider

      // Areas
      .state('project/areas', {
        url: '/project/{projectId}/building/{buildingId}/areas',
        component: 'sg2AreasView',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Ruimteblad]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.projectId, true);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      // Areas legacy.
      // May be a good idea to keep for a little while, in case something goes wrong
      // with the new areas page.
      // Accessed by adding '/v1' to the url.
      .state('project/areas/v1', {
        url: '/project/{project_id}/building/{building_id}/areas/v1',
        templateUrl: 'app-legacy/project/areas/areas.html',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[BuildingName] - [Ruimtestaat]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: [['building', '{building_id}'], ['cluster']]
            }
          }, {
            room: '/project/:id',
            includes: {
              path: [['building', '{building_id}'], ['area']]
            }
          }
        ],
        controller: 'ProjectAreasCtrl',
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
        }
      })

      // Area
      .state('project/area', {
        url: '/project/{projectId}/building/{buildingId}/areas/{areaId}',
        component: 'sg2AreaDetailsView',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[BuildingName] - [AreaName] - [Ruimteblad]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.projectId);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      // Basic Area
      .state('project/basic-area', {
        url: '/project/{projectId}/basic-areas/{basicAreaId}',
        component: 'sg2AreaDetailsView',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Ruimte template overzicht] - [BasicAreaName] [bewerken]'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.projectId);
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      })

      .state('project/areas/matrix', {
        url: '/project/{project_id}/building/{building_id}/matrix-overview',
        templateUrl: 'app-legacy/project/areas/matrix/matrix.html',
        controller: 'AreasMatrixCtrl',
        controllerAs: '$AreasMatrixCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[BuildingName]  - ruimtematrix'
        },
        authenticate: true,
        needRole: 1,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
          projectLevel: [function () {
            return 5;
          }]
        }
      });
  }
})();
